// Case Paper Action Types - Single API approach

// Get Case Paper Data (Single comprehensive API call)
export const GET_CASE_PAPER_DATA_REQUEST = "GET_CASE_PAPER_DATA_REQUEST";
export const GET_CASE_PAPER_DATA_SUCCESS = "GET_CASE_PAPER_DATA_SUCCESS";
export const GET_CASE_PAPER_DATA_FAILURE = "GET_CASE_PAPER_DATA_FAILURE";

// Clear Case Paper Data
export const CLEAR_CASE_PAPER_DATA = "CLEAR_CASE_PAPER_DATA";
